import axios from "axios";
import { ip_back } from "../../../config";
import { formatDate, getDurationTS, getDurationExercise } from "../dataFormat";

//import { getOtherTrainings as getOtherTrainingsM } from "../../mock/home/MockOtherTrainings";

import others1 from "../../assets/others1.jpg"
import others2 from "../../assets/landing_bg_img.jpg"
import others3 from "../../assets/others2.jpg"
import others4 from "../../assets/others3.jpg"

const imgs = [others1, others2, others3, others4];
const imgs2 = [others4, others3, others2, others1];

const adaptData = async (data) => {
    var adaptedData = []

    for (let i = 0; i < data.length; i++) {
        const ts = data[i];

        adaptedData.push({
            name: "Heading " + ts.ts_id.substring(0, 16), 
            type: 'Sessions', 
            duration: await getDurationTS(ts.tbl_training_exercises) + " min", 
            datetime: await formatDate(ts.ts_date + " " + ts.time_id), 
            image: imgs[i % 4] 
        },)

        for (let j = 0; j < ts.tbl_training_exercises.length; j++) {
            const exe = ts.tbl_training_exercises[j];
            adaptedData.push({
                name: exe.tbl_exercise.ex_name, 
                type: 'Exercises', 
                duration: await getDurationExercise(exe) + " min", 
                datetime: await formatDate(exe.te_date + " " + exe.te_start_time), 
                image: imgs2[j % 4] 
            },)
        }
    }
    return adaptedData;
}

export const getOtherTrainings = async (token) => {
    //var rpta_mock = await getOtherTrainingsM(token);

    //use API
    var config = {
        method: 'get',
        url: ip_back + '/api/training/getTrainingSessionList',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    };

    var rpta = {
        status: 'error',
        message: 'Network error',
        data: null
    };

    await axios(config)
        .then(async function (response) {
            rpta = response.data;

            const adaptedData = await adaptData(rpta.data)
            //rpta.data = [...adaptedData, ...rpta_mock.data];
            rpta.data = [...adaptedData];
        })
        .catch(function (error) {
            console.log(error);
        });

    return rpta;
};